<template>
  <div class="d-flex">
      <date-time placeholder="Von" @changed="fromChanged" :dark="dark" ref="from" />
      <date-time placeholder="Bis" @changed="toChanged" :dark="dark" ref="to" />
  </div>
</template>

<script>

import DateTime from './DateTime';

export default {
  name: 'DateRange',
  components: {
    DateTime,
  },
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
  },
  computed: {
  },
  methods: {
    clear() {
      this.$refs.from.clear();
      this.$refs.to.clear();
      this.from = null;
      this.to = null;
    },
    fromChanged(from) {
      this.from = from;
      this.notifyChanged();
    },
    toChanged(to) {
      this.to = to;
      this.notifyChanged();
    },
    notifyChanged() {
      this.$emit('changed', {
        from: this.from,
        to: this.to,
      });
    },
  },
  data: () => ({
    from: null,
    to: null,
  }),
};
</script>
